import { render, staticRenderFns } from "./PersonnelDetail.vue?vue&type=template&id=9e142b24&scoped=true&"
import script from "./PersonnelDetail.vue?vue&type=script&lang=ts&"
export * from "./PersonnelDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PersonnelDetail.vue?vue&type=style&index=0&id=9e142b24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e142b24",
  null
  
)

export default component.exports